import { parse, parseUrl } from 'query-string';
import { LanguageType } from '../../../types/language';
import { appendLocalStorage, getLocalStorage } from '../localStorage';
import { isDev } from '../util';
import { LinkType, NativeApi, Platform } from './interface';
import { getDevIsUIv2, getDevLang } from './utils';

const MOBILE_TOKEN = 'mobile_token';
const MOBILE_H5_LANG = 'mobile_h5_lang';

// web H5

export const mobileWebClient: NativeApi = {
  name: Platform.MobileWebClient,
  token: '',
  h5LinkType: undefined,
  isNewVersion: undefined,
  async init(options = {}) {
    const { initLangCallBack } = options;
    const { query } = parseUrl(location.href);
    this.token = (query.token as string) || '';
    initLangCallBack?.(this?.getLanguage() as LanguageType);
  },
  getLanguage: () => {
    const params = parse(location.search);
    const lowerLang = params.lang?.toString().toLocaleLowerCase();
    if (lowerLang) {
      appendLocalStorage(MOBILE_H5_LANG, { lang: lowerLang });
      return lowerLang || getDevLang();
    }
    const lang = getLocalStorage(MOBILE_H5_LANG)?.lang;
    if (lang) {
      return lang || getDevLang();
    }
    return getDevLang();
  },
  closeWindow: () => {
    // 跳到下载提示页面
    window.navigateFunc?.('/vhk/webPub/download');
  },
  gotoWhatsApp: () => {
    location.href = 'https://wa.me/85263692338';
  },
  getToken() {
    if (!this.token) {
      this.token = getLocalStorage(MOBILE_TOKEN).token || '';
    }
    return this.token;
  },
  setToken(token: string) {
    this.token = token;
    appendLocalStorage(MOBILE_TOKEN, { token });
  },
  setH5LinkType(linkType: LinkType) {
    this.h5LinkType = linkType;
  },
  getRequestHeader() {
    return {
      uiVersion: this.isNewVersion ? 'N' : 'O',
    };
  },
  setIsNewVersion(isNewVersion: boolean) {
    this.isNewVersion = isNewVersion;
  },
  getIsNewVersion() {
    if (typeof this.isNewVersion !== 'boolean') {
      // 暂时还没保存下来，读取数据
      if (isDev()) {
        // 开发场景直接读代码配置
        this.isNewVersion = getDevIsUIv2();
        return this.isNewVersion;
      }
      const params = parse(location.search); // 使用到的位置：1、H5内部使用 2、后台配置的facecard链接参数
      if (
        import.meta.env.VITE_APP_NEW_VERSION === 'true' &&
        (params.isNewVersion === 'Y' || params.newVersion === 'Y')
      ) {
        this.isNewVersion = true;
        return this.isNewVersion;
      }
      this.isNewVersion = false;
      return this.isNewVersion;
    }
    return this.isNewVersion;
  },
};
